import React from 'react';

import Typography from '@mui/material/Typography';
import theme from "../theme"

import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Footer from './Footer';
import SendLogsButton from './SendLogsButton';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: "18%",
    [theme.breakpoints.up("sm")]: {
      marginTop: "10%",
    },

    [theme.breakpoints.up("md")]: {
      marginTop: "6%",
    },


  },
  emailLink: {
    fontSize: 'small',
    textDecoration: 'none',
    color: "#4B4B4B",
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  version: {
    fontSize: 'small',
    bottom: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
  },
  text: {
    color: '#4B4B4B'
  }

}));

const HelpAndSupport = () => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <div className={classes.first}>
          <Typography variant="body2" component="p" className={classes.text}>
            Facing any issues? You can reach out to us at{' '}
            <a
              href="mailto:support@elhi.tech"
              className={classes.emailLink}
            >
              support@elhi.tech
            </a>
            .
          </Typography>
        </div>
        <div className={classes.second}>
          <Typography variant="body2" component="p" className={classes.text}>
            Visit{' '}
            <a
              href="https://support.elhi.tech"
              className={classes.emailLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              support.elhi.tech
            </a>{' '}
            to raise a ticket or to access support articles.
          </Typography>
        </div>
        <SendLogsButton />
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default HelpAndSupport;
